import { Experiences, Permissions } from '@local/client-contracts';
import type { DeepPartial } from '@local/ts-infra';
import { invoker } from '@unleash-tech/js-rpc';
import { Observable } from 'rxjs';

export class ExperiencesRpcInvoker implements Experiences.Service {
  @invoker
  getExperience$(id: string, cache: Experiences.CacheType): Observable<Experiences.ExperienceItem> {
    return;
  }

  @invoker
  updateById(
    body: Experiences.ExperienceItem,
    unavailableFilterSourceIds?: number[],
    ignoreUpdateDataSources?: boolean,
    toolIds?: string[]
  ): Promise<Experiences.ExperienceUpdateResponse> {
    return;
  }

  @invoker
  updatePartialSettingsById(id: string, updatedData: DeepPartial<Experiences.AnyExperienceSettings>): Promise<void> {
    return;
  }

  @invoker
  updatePartialDraftSettingsById(
    assistant: Experiences.ExperienceItem,
    updatedDataSettings: DeepPartial<Experiences.AnyExperienceSettings>
  ): Promise<void> {
    return;
  }

  @invoker
  updateShareOptions(id: string, shareOptions: Permissions.ShareOptions): Promise<void> {
    return;
  }

  @invoker
  refresh$(): Observable<void> {
    return;
  }

  @invoker
  get all$(): Observable<Experiences.ExperienceItem[]> {
    return;
  }

  @invoker
  create(
    type: Experiences.ExperienceType,
    body?: Experiences.ExperienceItemData,
    unavailableFilterSourceIds?: number[]
  ): Promise<Experiences.ExperienceItem> {
    return;
  }

  @invoker
  delete(id: string): Promise<void> {
    return;
  }

  @invoker
  getSharedObjects(accountId: string): Promise<Experiences.ExperienceSharedObjects> {
    return;
  }

  @invoker
  getSlackExperts$(slackDefaultLinkId: string, conversationId: string): Observable<Experiences.SlackExpertResponse> {
    return;
  }
}
